<template>
    <van-popup v-model="show" round position="center" @click-overlay="close">
        <div class="content">
            <div class="header">
                <div>Agregar a la pantalla de inicio</div>
                <div class="close">
                    <i class="iconfont icon-s-cuowu-guanbi" @click="close"></i>
                </div>
            </div>
            <video class="video_box" controls autoplay playsinline loop>
                <source type="video/mp4" src="@/assets/downApp/iosPwaTips.mp4">
            </video>
            <p class="tips-text"> Agregar esta aplicación a tu escritorio puede mejorar la fluidez del juego y proporcionar una mejor experiencia en general. </p>
            <p class="step-text"><span class="dot">1</span>Toca “Compartir”</p>
            <p class="step-text"><span class="dot">2</span>Selecciona “Más”</p>
            <p class="step-text"><span class="dot">3</span>Luego elige “Agregar a la pantalla de inicio”</p>
        </div>
    </van-popup>
</template>

<script>
export default {
    data() {
        return {
            show: false
        }
    },
    props: {
        isToHome: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        open() {
            this.show = true
        },
        close() {
            this.show = false
            this.toHome()
        },
        toHome() {
            if (!this.isToHome) return
            this.onPageRefresh()
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.van-popup {
    background: transparent;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
}

.content {
    background: $bg-popup-color;
    width: 94%;
    max-width: 500px;
    // height: 700px;
    border-radius: .24rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 0 .28rem;
    box-sizing: border-box;
    padding-bottom: .22rem;

    .header {
        display: flex;
        height: .98rem;
        // padding: 0 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &>div:first-child {
            font-size: .26rem;
            font-weight: bold;
            color: #fff;
        }

        .close {
            color: $font-iconfont-color;
            font-size: .42rem;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
                color: #ffffff;
                rotate: -180deg;
            }
        }
    }

    .video_box {
        width: 100%;
        height: 3rem;
        border-radius: .24rem;
        overflow: hidden;
    }

    .tips-text{
        color: #19df19;
        line-height: 1.5;
        font-size: .24rem;
        text-align: left;
        margin-top: .2rem;
    }
    .step-text{
        justify-content: flex-start;
        margin: .2rem auto;
        font-weight: 500;
        line-height: 1.5;
        font-size: .24rem;
        display: flex;
        align-items: center;
        color: #fff;
        text-align: left;
        margin: .1rem 0;
        .dot{
            width: .4rem;
            height: .4rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 100%;
            background: #2e3246;
            margin-right: .15rem;
            color: #fff;
            position: relative;
            overflow: hidden;
            transition: all .3s ease;
            font-size: .26rem;
        }
    }
}
</style>
